require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.symbol.observable');
require('../modules/es7.observable');
module.exports = require('../modules/_core').Observable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/observable.js
// module id = 529
// module chunks = 0